import React from 'react'
import { useSelector } from 'react-redux'
import { Card, Tooltip, Popconfirm, Typography, Avatar, Row, Col, Divider, Space } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClock, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { ActionButton } from '@/ui/ActionButton'
import styled from 'styled-components'

const { Text } = Typography

const StyledCard = styled(Card)`
  border-radius: 10px;
  margin: 12px 0;
  transition: all 0.3s;
  &:hover {
    background: #f5faff;
  }
`

interface IconWithTooltipProps {
  icon: IconProp
  text: React.ReactNode
  tooltip: React.ReactNode
}

const IconWithTooltip: React.FC<IconWithTooltipProps> = ({ icon, text, tooltip }) => (
  <Tooltip title={tooltip}>
    <Space style={{ marginRight: 20 }}>
      <FontAwesomeIcon icon={icon} style={{ color: '#555' }} />
      <Text type="secondary">{text}</Text>
    </Space>
  </Tooltip>
)

interface FollowUpComment {
  id: string | number
  message: string
  userProfileImages?: string
  create_time: string
  create_user: string
}

interface FollowUpCommentModernProps {
  followUpComment: FollowUpComment
  handleCommentUpdate: (id: string | number) => void
  handleCommentDelete: (id: string | number) => void
  hideUpdate?: boolean
  hideDelete?: boolean
}

const FollowUpCommentModern: React.FC<FollowUpCommentModernProps> = ({
  followUpComment: { id, message, userProfileImages, create_time, create_user },
  handleCommentUpdate,
  handleCommentDelete,
  hideUpdate = false,
  hideDelete = false,
}) => {
  const {
    auth: { authUser } = { authUser: undefined },
  } = useSelector((state: any) => state)
  const isOwner = authUser?.user_name === create_user

  return (
    <StyledCard>
      <Row gutter={12}>
        <Col span={2}>
          <Avatar shape="square" size={40} src={userProfileImages} />
        </Col>
        <Col span={22}>
          <Text style={{ whiteSpace: 'pre-line' }}>{message}</Text>
        </Col>
      </Row>
      <Divider style={{ marginTop: 12, marginBottom: 12 }} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Space wrap>
          <IconWithTooltip icon={faClock} text={create_time} tooltip="Create time" />
          <IconWithTooltip icon={faPencilAlt} text={create_user} tooltip="Create user" />
        </Space>

        {isOwner && (
          <Space wrap>
            {!hideUpdate && (
              <ActionButton type='button' $type='edit' onClick={() => handleCommentUpdate(id)} />
            )}
            {!hideDelete && (
              <Popconfirm
                title="Are you confirm to delete?"
                onConfirm={() => handleCommentDelete(id)}
                cancelButtonProps={{ style: { paddingTop: 0 } }}
              >
                <ActionButton type='button' $type='delete' />
              </Popconfirm>
            )}
          </Space>
        )}
      </div>
    </StyledCard>
  )
}

export default FollowUpCommentModern
